import { useTheme } from "../hooks/useTheme";
import { cn } from "../lib/utils";
import { Sun, Moon } from "./Icon";

export default function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      // cn() so a caller-supplied text colour actually wins over the default.
      className={cn(
        "grid h-9 w-9 place-items-center text-foreground transition-colors hover:text-primary",
        className
      )}
    >
      {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
}
